import { render, staticRenderFns } from "./poster-page.vue?vue&type=template&id=1a36030e&scoped=true&"
import script from "./poster-page.vue?vue&type=script&lang=js&"
export * from "./poster-page.vue?vue&type=script&lang=js&"
import style0 from "./poster-page.vue?vue&type=style&index=0&id=1a36030e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36030e",
  null
  
)

export default component.exports